
export class ExpandMode {
public static None = 'None';
public static Selection = 'Selection';
public static All = 'All';
}

function ExpandMode_tsickle_Closure_declarations() {
/** @type {?} */
ExpandMode.None;
/** @type {?} */
ExpandMode.Selection;
/** @type {?} */
ExpandMode.All;
}

